import { create } from 'zustand'
import type { Organization } from '../lib/api'

interface UserProfile {
  id: string
  email?: string | null
  organization_id: string | null
  full_name: string | null
  role: string | null
  is_super_admin?: boolean
}

interface AppState {
  organizationId: string | null
  currentUser: UserProfile | null
  organization: Organization | null
  setOrganizationId: (id: string | null) => void
  setCurrentUser: (user: UserProfile | null) => void
  setOrganization: (org: Organization | null) => void
}

export const useAppStore = create<AppState>((set) => ({
  organizationId: null,
  currentUser: null,
  organization: null,
  setOrganizationId: (id) => set({ organizationId: id }),
  setCurrentUser: (user) => set({
    currentUser: user,
    organizationId: user?.organization_id || null,
  }),
  setOrganization: (org) => set({ organization: org }),
}))
